module.exports = __webpack_public_path__ + "images/9906de7c.img2-usa.png";


//////////////////
// WEBPACK FOOTER
// ./images/indexV2/img2-usa.png
// module id = 402
// module chunks = 0